import { TableOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useState } from "react";
import "../../assets/scss/riskMatrixTable.scss";
import RiskMatrixTable from "./RiskMatrixTable";

function RiskMatrixModal({ buttonLabel }: { buttonLabel?: string }) {
	const [isOpen, setIsOpen] = useState(false);

	const handleOpen = () => {
		setIsOpen(true);
	};

	const handleClose = () => {
		setIsOpen(false);
	};

	return (
		<>
			<Button className="p-0! text-sm" type="link" onClick={handleOpen}>
				<span>
					<TableOutlined />
				</span>
				<span>{buttonLabel || "View risk impact/probability"}</span>
			</Button>
			<Modal
				title="Risk matrix"
				open={isOpen}
				centered
				onCancel={handleClose}
				width={"80vw"}
				bodyProps={{ style: { maxHeight: "70vh", overflowY: "auto" } }}
				footer={() => <Button onClick={handleClose}>Close</Button>}
				closeIcon={null}
			>
				<RiskMatrixTable />
			</Modal>
		</>
	);
}

export default RiskMatrixModal;
